import type { OrderDetailsOrder } from '@/types/orderDetailsOrder';

export { isReturnableLine } from '@/lib/withdrawal/returnableOrderLine';

export function getShippingDisplayName(order: OrderDetailsOrder) {
  const sa = order.shippingAddress;
  if (!sa) {
    return '';
  }
  const named = [sa.firstName, sa.lastName].filter(Boolean).join(' ').trim();
  if (named) {
    return named;
  }
  return sa.companyName ?? '';
}
